function e(e){return(null==e?void 0:e.placement)?[e.channel,e.device,e.page,e.placement].join("/").toLowerCase():[e.channel,e.device,e.page,e.slot].join("/").toLowerCase()}export{e as buildAdsEventPath};
